export const processData = {
  hero: {
    badge: "HOW IT WORKS",
    headline: "Simple Process, Powerful Results",
    description:
      "We've perfected a 4-step system that consistently fills aesthetic clinics with high-quality patients. No guesswork, no wasted ad spend just predictable growth.",
  },

  funnel: {
    title: "Our Proven Marketing Funnel",
    subtitle: "From first click to confirmed booking automated and optimized",
    steps: [
      {
        id: 1,
        iconName: "Target",
        title: "Targeted Ads",
        description:
          "We run precision-targeted campaigns on Meta & Google to attract patients actively searching for aesthetic treatments.",
        color: "#60a5fa",
      },
      {
        id: 2,
        iconName: "Users",
        title: "Qualifying Leads",
        description:
          "Our medically trained team vets every inquiry, qualifying patients and filtering out time wasters.",
        color: "#a78bfa",
      },
      {
        id: 3,
        iconName: "Calendar",
        title: "Confirm Booking Date",
        description:
          "Qualified leads are seamlessly booked into your calendar with automated confirmations and reminders.",
        color: "#34d399",
      },
      {
        id: 4,
        iconName: "Shield",
        title: "Secure Deposit",
        description:
          "We collect deposits upfront to ensure serious patients and protect your calendar from no-shows.",
        color: "#fbbf24",
      },
    ],
  },

  detailedSteps: [
    {
      step: "01",
      title: "Targeted Ads",
      headline: "We Put Your Clinic in Front of Ready-to-Buy Patients",
      description:
        "We don't waste your budget on random clicks. Our campaigns target people actively searching for treatments like fillers and laser services in your area.",
      features: [
        "Hyper-targeted audiences (age, location, interests, behavior)",
        "A/B tested ad creatives designed to convert",
        "Real-time campaign optimization",
        "Detailed performance tracking & reporting",
      ],
      result: "Average Cost Per Lead: 40% lower than industry standard",
      image:
        "https://images.unsplash.com/photo-1714974529509-71f2c9361b76?q=80&w=2064&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      step: "02",
      title: "Qualifying Leads",
      headline: "Only Serious Patients Make It Through",
      description:
        "Our medically trained team personally vets every lead. We ask the right questions, verify interest, and ensure they're a good fit before they ever reach your calendar.",
      features: [
        "Dedicated team handles all inquiries",
        "Pre-consultation questionnaires",
        "Budget and treatment verification",
        "Immediate follow-up (no leads go cold)",
      ],
      result: "85%+ of booked consultations convert to treatments",
      image:
        "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80",
    },
    {
      step: "03",
      title: "Confirm Booking Date",
      headline: "Appointments Flow Directly Into Your Calendar",
      description:
        "Once qualified, patients are booked instantly. Our system syncs with your calendar, sends automated confirmations, and follows up with reminders so no-shows become rare.",
      features: [
        "Calendar integration (Google Calendar, Calendly, custom CRM)",
        "Automated SMS & email confirmations",
        "Pre-appointment reminders (48hrs & 24hrs before)",
        "Easy rescheduling options",
      ],
      result: "No-show rate reduced by 85% with our reminder system",
      image:
        "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=800&q=80",
    },
    {
      step: "04",
      title: "Secure Deposit",
      headline: "Protect Your Time and Revenue",
      description:
        "We collect non-refundable deposits at booking to lock in serious patients. This step alone eliminates last-minute cancellations and ensures you're only seeing committed clients.",
      features: [
        "Automated deposit collection via Stripe",
        "Customizable deposit amounts per treatment",
        "Deposits applied to final treatment cost",
        "Instant payment confirmations",
      ],
      result: "95% booking retention rate with deposit system",
      image:
        "https://images.unsplash.com/photo-1758526213756-9aecbea6bcfc?q=80&w=2064&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
  ],

  performanceModel: {
    badge: "PERFORMANCE-BASED",
    headline: "We Only Win When You Win",
    description:
      "Unlike traditional agencies that charge you regardless of results, our model is built on your success. We're invested in filling your calendar not just running ads.",
    stats: [
      {
        number: "1400+",
        label: "Confirmed Bookings",
        description: "Delivered to clinics last year",
      },
      {
        number: "4+",
        label: "Years Experience",
        description: "Specializing in managing aesthetic clinics",
      },
      {
        number: "85%",
        label: "Success Rate",
        description: "Qualified leads convert to treatments",
      },
      {
        number: "24/7",
        label: "Support Available",
        description: "Our team is always on call",
      },
    ],
    features: [
      "You only pay for confirmed, qualified bookings",
      "No long-term contracts cancel anytime",
      "Full transparency with real-time dashboards",
      "Dedicated account manager assigned to your clinic",
    ],
  },
};
